package nl.volleyplanner.util

fun <T, R> List<T>.mapWithPrevious(initial: R, transform: (index: Int, T, R) -> R): List<R> {
    val result = mutableListOf<R>()
    var previous = initial

    for (index in indices) {
        val current = transform(index, this[index], previous)
        result.add(current)
        previous = current
    }

    return result
}
